import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { AssessmentSessionManagement } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/assessment-sessions")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <AssessmentSessionManagement />
    </RouteGuard>
  ),
});
